export enum RegisterType {
    CREATED = "CREATED",
    UPDATED = "UPDATED",
    DELETED = "DELETED",
}